export const MY_FEED_ID = 'MY_FEED_ID';
export const MY_BOOKMARKS_ID = 'MY_BOOKMARKS_ID';
